/* eslint-disable import/no-anonymous-default-export */
export default (undefinedRate = [], action) => {
  switch (action.type) {
    case "GET_ALL_UNDEFINED_INVESTMENTS":
      return action.payload;
    case "CREATE_UNDEFINED_INVESTMENT":
      return [...undefinedRate, action.payload];

    default:
      return undefinedRate;
  }
};
